import { TOA_GetFreshShipmentShipGroups } from '@/types.gql';

export enum FreshShipmentActions {
  UPDATE_SHOW_FORM = 'freshShipment/UPDATE_SHOW_FORM',
  UPDATE_FRESH_SHIPMENT_GROUPS = 'freshShipment/UPDATE_FRESH_SHIPMENT_GROUPS',
  SET_SELECTED_ROWS = 'freshShipment/SET_SELECTED_ROWS',
  UPDATE_SIGNED_OFF = 'freshShipment/UPDATE_SIGNED_OFF',
  UPDATE_IS_CSR = 'freshShipment/UPDATE_IS_CSR',
  UPDATE_QC_LOADED = 'freshShipment/UPDATE_QC_LOADED',
  SET_SELECTED_SHIPMENT_GROUPS = 'freshShipment/SET_SELECTED_SHIPMENT_GROUPS',
  UPDATE_PREDICTION_TECH_LOADING = 'freshShipment/UPDATE_PREDICTION_TECH_LOADING',
}

export type FreshShipmentType = {
  showForm: boolean | undefined;
  shipmentGroup: TOA_GetFreshShipmentShipGroups | undefined;
  selectedRows: string[];
  signedOff: boolean;
  isCsr: boolean;
  qcLoaded: boolean;
  selectedShipmentGroups: { id: string; value: string }[];
  predictionTechLoading: boolean;
};

export const initialState: FreshShipmentType = {
  showForm: undefined,
  shipmentGroup: undefined,
  selectedRows: [],
  signedOff: false,
  isCsr: false,
  qcLoaded: false,
  selectedShipmentGroups: [],
  predictionTechLoading: false,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case FreshShipmentActions.UPDATE_SHOW_FORM: {
      return {
        ...state,
        showForm: action.showForm,
      };
    }
    case FreshShipmentActions.UPDATE_FRESH_SHIPMENT_GROUPS: {
      return {
        ...state,
        shipmentGroup: action.shipmentGroup,
      };
    }
    case FreshShipmentActions.SET_SELECTED_ROWS: {
      return {
        ...state,
        selectedRows: action.selectedRows,
      };
    }
    case FreshShipmentActions.UPDATE_SIGNED_OFF: {
      return {
        ...state,
        signedOff: action.signedOff,
      };
    }
    case FreshShipmentActions.UPDATE_IS_CSR: {
      return {
        ...state,
        isCsr: action.isCsr,
      };
    }
    case FreshShipmentActions.UPDATE_QC_LOADED: {
      return {
        ...state,
        qcLoaded: action.qcLoaded,
      };
    }

    case FreshShipmentActions.SET_SELECTED_SHIPMENT_GROUPS: {
      return {
        ...state,
        selectedShipmentGroups: action.selectedShipmentGroups,
      };
    }
    case FreshShipmentActions.UPDATE_PREDICTION_TECH_LOADING: {
      return {
        ...state,
        predictionTechLoading: action.predictionTechLoading,
      };
    }

    default:
      return state;
  }
}
